import { ActionTypes } from './actionTypes';
import type { AlarmsAction } from './actions';

import type { IncidentWithAddress } from '@cobliteam/common-types';

import { type WebData, webDataError, webDataFetching, webDataNotAsked, webDataSuccess } from '@cobliteam/api-lib';

export interface AlarmsState {
  incidentsWebData: WebData<IncidentWithAddress[]>;
}

export const alarmsInitialState: AlarmsState = {
  incidentsWebData: webDataNotAsked(),
};

export const alarmsReducer = (state: AlarmsState = alarmsInitialState, action: AlarmsAction): AlarmsState => {
  if (!(action.type in ActionTypes)) {
    return state;
  }

  switch (action.type) {
    case ActionTypes.LOAD_ALARMS_REQUEST:
      return {
        ...state,
        incidentsWebData: webDataFetching(),
      };

    case ActionTypes.LOAD_ALARMS_SUCCEEDED:
      return {
        ...state,
        incidentsWebData: webDataSuccess(action.payload),
      };

    case ActionTypes.LOAD_ALARMS_FAILED:
      return {
        ...state,
        incidentsWebData: webDataError(),
      };

    default:
      return state;
  }
};
